import { Libraries, useLoadScript } from '@react-google-maps/api';
import React, { createContext, FC, useMemo } from 'react';

export type GoogleMapProviderType = {
  isLoadedMapLibrary?: boolean;
  googleMapApiKey?: string;
  googleMapId?: string;
};

export const GoogleMapContext = createContext<GoogleMapProviderType>({});

interface Props {
  values: GoogleMapProviderType;
  children: React.ReactNode;
}

export const GoogleMapProvider: FC<Props> = ({ children, values }) => {
  const libraries = useMemo<Libraries>(() => ['places', 'marker'], []);

  const { isLoaded: isLoadedMapLibrary } = useLoadScript({
    googleMapsApiKey: values.googleMapApiKey || '',
    libraries,
    id: 'google-map-script',
  });

  const GoogleMapContextValue = useMemo<GoogleMapProviderType>(
    () => ({
      isLoadedMapLibrary,
      ...values,
    }),
    [values, isLoadedMapLibrary],
  );

  return <GoogleMapContext.Provider value={GoogleMapContextValue}>{children}</GoogleMapContext.Provider>;
};

export default GoogleMapProvider;
